<template>
    <div>
		<EditAccountClass
			v-if="modalAccountClass"
			:accountClassData="{}"
			@closeModal="closeAccountClass"
			@newAccountClass="setAccountClass"
			:name="nameAccountClass"
		/>
        <b-modal
            ref="modalEdit"
            hide-footer
            :title="titleModal"
            size="md"
            no-close-on-backdrop
            hide-header-close
            hide-header
            >
            <div class="title-modal">
                <div class="title-text-modal">{{ titleModal }}</div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeModal('modalEdicao')"
                >
                    <xIcon/>
                </div>
            </div>
            <div class="modal-edicao mb-3 modal-edicao-label mt-6">
                <b-row class="mb-3">
                    <b-col class="d-block text-parcela">
                        <span class="label-conta">Conta</span>
                        <b-form-input
                            name="description-conta"
                            class="modal-edicao-input"
                            type="text"
                            v-model="accountSelected.description"
                            autocomplete="off"
                            placeholder="Digite o nome da conta"
                            v-validate="'required|maxLength:50'"
                            :state="validateState('description-conta')"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col v-if="!closingMonthly" class="d-block text-parcela center">
                        <span class="label-conta toggle-conta">Mostrar no Dashboard</span>
                        <ToggleSwitch
                            name="conta-close-monthly"
                            class="toggle-conta"
                            :value="accountSelected.sumBalanceDashboard"
                            @toggle="_ => changeToggle('sumBalanceDashboard')"
                        />
                    </b-col>
                    <b-col class="d-block text-parcela center">
                        <span class="label-conta toggle-conta">Inativa</span>
                        <ToggleSwitch
                            name="conta-close-monthly"
                            class="toggle-conta"
                            :value="accountSelected.inactive"
                            @toggle="_ => changeToggle('inactive')"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="d-block text-parcela mb-2">
                        <span class="label-conta">Tipo de Conta</span>
						<SearchSelect
							name="accountClass"
							:options="accountClassOptions"
							:visibleSuggestion="visibleSuggestion.accountClass"
							:isMobile="isMobile"
							:newRecord="newAccountClass"
							@changeSelect="changeSelect"
							@handleSuggestion="handleVisibleSuggestion"
							@invalidSearch="validateOptionSearch"
						/>
                    </b-col>
                </b-row>
                <b-row class="filters-orientation" v-if="closingMonthly">
                    <b-col class="d-block text-parcela mb-2">
                        <span class="label-conta">Dia de Fechamento</span>
                        <b-form-input
                            name="closing-day-conta"
                            class="modal-edicao-input"
                            type="number"
                            min="1"
                            max="31"
                            v-model="accountSelected.closingDay"
                            autocomplete="off"
                            placeholder="Dia de fechamento"
                            v-validate="{ required: true, min_value: 1, max_value: 31 }"
                            :state="validateState('closing-day-conta')"
                        />
                    </b-col>
                    <b-col class="d-block text-parcela mb-2">
                        <span class="label-conta">Dia de Pagamento</span>
                        <b-form-input
                            name="pay-day-conta"
                            class="modal-edicao-input"
                            type="number"
                            min="1"
                            max="31"
                            v-model="accountSelected.payDay"
                            autocomplete="off"
                            placeholder="Dia de pagamento"
                            v-validate="{ required: true, min_value: 1, max_value: 31 }"
                            :state="validateState('pay-day-conta')"
                        />
                    </b-col>
                    <b-col class="d-block text-parcela">
                        <span class="label-conta toggle-conta">Fec. Dia Útil Seg. <InfoIcon size="16" class="mb-1" v-b-tooltip.hover title="Essa opção faz com que uma compra com cartão de crédito feita no final de semana, se for dia de fechamento, seja lançada na segunda-feira seguinte." /></span>
                        <ToggleSwitch
                            name="conta-close-monthly"
                            class="toggle-conta"
                            :value="accountSelected.closeNextDayWeekend"
                            @toggle="_ => changeToggle('closeNextDayWeekend')"
                        />
                    </b-col>
                </b-row>
            </div>
            <b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="closeModal('modalEdicao')">Cancelar</b-button>
            <b-button class="mt-3 float-left btn-modal btn-limpar" @click="cleanModal()">Limpar</b-button>
            <b-button
                class="mt-3 ml-1 float-right btn-modal btn-salvar"
                @click="saveRecord"
                :disabled="invalidForm || saving || !accountSelected.idAccountClass"
            >
                Salvar
            </b-button>
        </b-modal>
    </div>
</template>

<script>
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { AccountService } from "@/services/account";
	import emitter from "@/eventBus.js";
	import ToggleSwitch from "@/components/ToggleSwitch";
	import { mapState } from "vuex";
	import EditAccountClass from "../AccountClass/EditAccountClass.vue";
	import SearchSelect from "@/components/SearchSelect.vue";

	export default {
		components: {
			ToggleSwitch,
			EditAccountClass,
			SearchSelect
		},

		props: {
			accountData: {
				type: Object,
				required: false
			},
			name: {
				type: String,
				required: false
			},
			isMobile: {
				type: Boolean,
				required: false
			}
		},

		inject: ["parentValidator"],

		data () {
			return {
				titleModal: "",
				accountSelected: {
					idAccount: "",
					description: "",
					closingDay: "",
					closeNextDayWeekend: false,
					idAccountClass: null,
					payDay: "",
					sumBalanceDashboard: false,
					inactive: false
				},
				accountService: new AccountService(),
				loading: true,
				noEditAccount: false,
				invalidForm: true,
				saving: false,
				closingMonthly: false,
				accountClassOptions: [],
				modalAccountClass: false,
				visibleSuggestion: {
					accountClass: false
				},
				nameAccountClass: "",
				newAccountClass: {},
				invalidSearch: {
					accountClass: true
				}
			};
		},

		computed: mapState(["accountClass", "account"]),

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			this.showAccount();
			this.findAccountClass();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			showAccount () {
				this.invalidForm = true;
				const {
					idAccount = "",
					description = "",
					closingDay = "",
					closeNextDayWeekend = false,
					idAccountClass = null,
					payDay = "",
					sumBalanceDashboard = false,
					inactive = false
				} = this.accountData;

				if (!idAccount) {
					this.accountSelected.description = this.name;
					this.titleModal = "Cadastrar Nova Conta";
					this.noEditAccount = true;
				} else {
					this.titleModal = "Editar Conta";
					this.accountSelected.description = description;
					this.nameAccountClass = (this.accountClass.find(ele => ele.idAccountClass === idAccountClass))?.description || null;
					this.noEditAccount = false;
					this.newAccountClass = {
						id: idAccountClass,
						description: this.nameAccountClass
					};
				}

				this.accountSelected.idAccount = idAccount;
				this.accountSelected.closingDay = closingDay;
				this.accountSelected.closeNextDayWeekend = closeNextDayWeekend ? closeNextDayWeekend : false;
				this.accountSelected.idAccountClass = idAccountClass;
				this.accountSelected.payDay = payDay;
				this.accountSelected.sumBalanceDashboard = sumBalanceDashboard ? sumBalanceDashboard : false;
				this.accountSelected.inactive = inactive ? inactive : false;
				this.validateAccountClass(idAccountClass);
				this.$refs.modalEdit.show();
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			closeModal () {
				this.$refs.modalEdit.hide();
				this.cleanModal();
				this.accountSelected.idAccount = "";
				this.saving = false;
				this.invalidForm = true;
				this.$emit("closeModal");
			},

			cleanModal () {
				this.accountSelected.description = "";
				this.accountSelected.closingDay = "";
				this.accountSelected.closeNextDayWeekend = false;
				this.accountSelected.idAccountClass = null;
				this.accountSelected.payDay = "";
				this.accountSelected.sumBalanceDashboard = false;
				this.accountSelected.inactive = false;
			},

			async saveRecord () {
				const invalidFields = await this.validateModal();
				if (invalidFields) {
					await this.$swal({
						title: "Formulário Inválido",
						text: "Existe informação sem preencher!",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return;
				}

				if (await this.recordExist()) {
					return;
				}

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};
				const payload = {
					idAccountClass: this.accountSelected.idAccountClass,
					description: this.accountSelected.description,
					closeNextDayWeekend: this.accountSelected.closeNextDayWeekend,
					payDay: this.accountSelected.payDay || null,
					closingDay: this.accountSelected.closingDay || null,
					sumBalanceDashboard: this.accountSelected.sumBalanceDashboard,
					inactive: this.accountSelected.inactive
				};

				if (this.accountSelected.idAccount)
					payload.idAccount = this.accountSelected.idAccount;

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						const newAccount = await this.accountService.upsertAccount({payload});

						this.$emit("findAccount", true);
						this.$emit("newAccount", newAccount);
						emitter.emit("reloadAccount", { reload: true });
						this.closeModal();

						return {
							title: "Sucesso!",
							body: "Conta salva com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar conta!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			async validateModal () {
				const validationFields = Object.keys(this.veeFields);
				if (!validationFields.length)
					return true;

				const validations = validationFields.reduce((acc, ref) => {
					if (this.veeFields[ref] && this.veeFields[ref].invalid)
						return [...acc, this.veeFields[ref].invalid];

					return acc;
				}, []);

				const invalidFields = validations.filter(field => field);
				return Boolean(invalidFields && invalidFields.length);
			},

			changeToggle (key) {
				this.accountSelected[key] = !this.accountSelected[key];
			},

			async validateAccountClass (idAccountClass) {
				if (idAccountClass)
					this.closingMonthly = await (this.accountClass.find(ac => ac.idAccountClass == idAccountClass))?.closeMonthly;
			},

			showAccountClass () {
				this.modalAccountClass = true;
			},

			closeAccountClass (cancelled) {
				if (cancelled) {
					this.nameAccountClass = "";
				}

				this.modalAccountClass = false;
			},

			setAccountClass (newAccountClass) {
				this.newAccountClass = {
					id: newAccountClass[0].idAccountClass,
					description: newAccountClass[0].description
				};

				this.accountSelected.idAccountClass = newAccountClass[0].idAccountClass;
				this.closingMonthly = newAccountClass[0].closeMonthly;
			},

			findAccountClass () {
				this.accountClassOptions = this.accountClass.reduce((acc, item) => {
					acc.push({
						text: item.description,
						value: item.idAccountClass
					});

					return acc;
				}, []);
			},

			changeSelect (option) {
				const { value, text, fatherComponent } = option;
				this.nameAccountClass = text;
				if (value) {
					this.accountSelected.idAccountClass = value;
					this.validateAccountClass(this.accountSelected.idAccountClass);
				} else {
					this.showAccountClass();
				}
			},

			validateOptionSearch (validateSearch) {
				this.invalidSearch[validateSearch.fatherComponent] = validateSearch.invalidSearch;
			},

			handleVisibleSuggestion (handleSuggestion) {
				this.visibleSuggestion[handleSuggestion.name] = handleSuggestion.visibleSuggestion;
			},

			async recordExist () {
				const recordExist = this.account.find(a => a.text === this.accountSelected.description && this.accountSelected.idAccount !== a.value);
				if (recordExist) {
					await this.$swal({
						title: "Registro já existe",
						text: "Não é possível criar o registro, altere o nome e tente novamente.",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return true;
				}

				return false;
			}
		}
	};
</script>
